// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 0px 10px;
  width: 100%;
}
.wrapper .wrapper-articles {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  flex-wrap: no-wrap;
  overflow-y: auto;
  padding: 10px;
  transition: flex-wrap 0.3s ease-in-out;
  position: relative;
}
.wrapper .wrapper-articles .item {
  min-width: 25%;
  padding: 0px 7px;
  margin-top: 5px;
  width: 25%;
  transition: max-width 0.3s ease-in-out;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles .item {
    min-width: 33%;
    max-width: 33%;
  }
}
.wrapper .wrapper-articles.show-list {
  flex-wrap: wrap;
}
.wrapper .wrapper-articles.show-list .item {
  max-width: 25%;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles.show-list .item {
    min-width: 33%;
  }
}
.wrapper .button-show-more {
  width: 95%;
  margin-top: 20px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 8px;
  margin: 20px auto 5px;
}
.wrapper .button-show-more p {
  font-family: AppFontBold;
  color: var(--ion-color-secondary);
  font-size: 16px;
}
.wrapper .button-show-more .arrow-down {
  padding: 5px;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  rotate: 0deg;
  transition: rotate 0.3s ease-in-out;
}
.wrapper .button-show-more .arrow-down.rotate {
  rotate: 540deg;
}

.back-icon {
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  z-index: 99;
  width: 30px;
  height: 30px;
  max-width: 30px;
  max-height: 30px;
}
.back-icon ion-icon {
  fill: white;
  color: white;
}

.next-icon {
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  z-index: 99;
  width: 30px;
  height: 30px;
  max-width: 30px;
  max-height: 30px;
}
.next-icon ion-icon {
  fill: white;
  color: white;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-custom/article-option-group-custom.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,iBAAA;EACA,WAAA;AADD;AAEC;EACC,aAAA;EAEA,2BAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sCAAA;EACA,kBAAA;AADF;AAEE;EAKC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,sCAAA;AAJH;ACbE;EDQA;IAEE,cAAA;IACA,cAAA;EAOF;AACF;AAAE;EACC,eAAA;AAEH;AADG;EAIC,cAAA;AAAJ;ACzBE;EDqBC;IAEE,cAAA;EAMH;AACF;AADC;EACC,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;EACA,kBAAA;EACA,qBAAA;AAGF;AAFE;EACC,wBAAA;EACA,iCAAA;EACA,eAAA;AAIH;AAFE;EACC,YAAA;EACA,4CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,mCAAA;AAIH;AAHG;EACC,cAAA;AAKJ;;AAAA;EACC,gBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAGD;AAFC;EACC,WAAA;EACA,YAAA;AAIF;;AADA;EACC,gBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAID;AAHC;EACC,WAAA;EACA,YAAA;AAKF;;AADA;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAID","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\tpadding: 0px 10px;\n\twidth: 100%;\n\t.wrapper-articles {\n\t\tdisplay: flex;\n\n\t\tjustify-content: flex-start;\n\t\twidth: 100%;\n\t\tflex-wrap: no-wrap;\n\t\toverflow-y: auto;\n\t\tpadding: 10px;\n\t\ttransition: flex-wrap 0.3s ease-in-out;\n\t\tposition: relative;\n\t\t.item {\n\t\t\t@include mobile {\n\t\t\t\tmin-width: 33%;\n\t\t\t\tmax-width: 33%;\n\t\t\t}\n\t\t\tmin-width: 25%;\n\t\t\tpadding: 0px 7px;\n\t\t\tmargin-top: 5px;\n\t\t\twidth: 25%;\n\t\t\ttransition: max-width 0.3s ease-in-out;\n\t\t}\n\t\t&.show-list {\n\t\t\tflex-wrap: wrap;\n\t\t\t.item {\n\t\t\t\t@include mobile {\n\t\t\t\t\tmin-width: 33%;\n\t\t\t\t}\n\t\t\t\tmax-width: 25%;\n\t\t\t}\n\t\t}\n\t}\n\t.button-show-more {\n\t\twidth: 95%;\n\t\tmargin-top: 20px;\n\t\tpadding: 5px 10px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder: 1px solid var(--ion-color-secondary);\n\t\tborder-radius: 8px;\n\t\tmargin: 20px auto 5px;\n\t\tp {\n\t\t\tfont-family: AppFontBold;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tfont-size: 16px;\n\t\t}\n\t\t.arrow-down {\n\t\t\tpadding: 5px;\n\t\t\tborder: 1px solid var(--ion-color-secondary);\n\t\t\tborder-radius: 50%;\n\t\t\twidth: 25px;\n\t\t\theight: 25px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tmargin-left: 5px;\n\t\t\trotate: 0deg;\n\t\t\ttransition: rotate 0.3s ease-in-out;\n\t\t\t&.rotate {\n\t\t\t\trotate: 540deg;\n\t\t\t}\n\t\t}\n\t}\n}\n.back-icon {\n\tposition: sticky;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tleft: 10px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 10px;\n\tborder-radius: 50%;\n\tbackground: var(--ion-color-primary);\n\tz-index: 99;\n\twidth: 30px;\n\theight: 30px;\n\tmax-width: 30px;\n\tmax-height: 30px;\n\tion-icon {\n\t\tfill: white;\n\t\tcolor: white;\n\t}\n}\n.next-icon {\n\tposition: sticky;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tright: 10px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 10px;\n\tborder-radius: 50%;\n\tbackground: var(--ion-color-primary);\n\tz-index: 99;\n\twidth: 30px;\n\theight: 30px;\n\tmax-width: 30px;\n\tmax-height: 30px;\n\tion-icon {\n\t\tfill: white;\n\t\tcolor: white;\n\t}\n}\n\n.visually-hidden {\n\tposition: absolute;\n\twidth: 1px;\n\theight: 1px;\n\tmargin: -1px;\n\tpadding: 0;\n\toverflow: hidden;\n\tclip: rect(0, 0, 0, 0);\n\twhite-space: nowrap;\n\tborder: 0;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
